import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Layout from './components/Layout/Layout';
import UsersPage from './pages/UsersPage';
import ComplaintsPage from './pages/ComplaintsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import MessagesPage from './pages/Messages/MessagesPage';
import VerificationPage from './pages/VerificationPage';
import BroadcastPage from './pages/BroadcastPage';
import LoginPage from './pages/LoginPage';
import { useAuth } from './contexts/AuthContext';
import './index.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Пока идёт проверка токена по /admin/auth/me — ничего не редиректим.
  if (loading) {
    return null;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/analytics" replace />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="complaints" element={<ComplaintsPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="verification" element={<VerificationPage />} />
          <Route path="broadcast" element={<BroadcastPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/analytics" replace />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
